import { render, staticRenderFns } from "./TestQuestionMedia.vue?vue&type=template&id=7674051d&scoped=true&"
import script from "./TestQuestionMedia.vue?vue&type=script&lang=js&"
export * from "./TestQuestionMedia.vue?vue&type=script&lang=js&"
import style0 from "./TestQuestionMedia.vue?vue&type=style&index=0&id=7674051d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7674051d",
  null
  
)

export default component.exports